import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = () => {
  return <div className={styles.spinner}></div>;
};

export default LoadingSpinner;
